/*
 * The proof points.
 *
 * The heading reveals on arrival, then the section pins and the cards travel
 * across tied to scroll position — the same sub-scroll mechanic as the range
 * card, so the two read as a pair rather than two different ideas.
 */
import {
	defineScene,
	revealText,
	horizontalScroll,
	scenePriority,
	enterConfig,
} from '@theme/about-story';

defineScene('about-mentions', (root, gsap) => {
	const heading = root.querySelector('[data-about-heading]');
	const window_ = root.querySelector('[data-about-window]');
	const track = root.querySelector('[data-about-track]');

	if (heading) {
		const timeline = gsap.timeline({
			...enterConfig(heading ?? root),
		});
		revealText(heading, { timeline, position: 0.15 });
	}

	if (track && window_) {
		horizontalScroll(root, track, {
			viewport: window_,
			/* The wrapper, not <about-mentions>: pinning moves the node it pins. */
			pin: root.querySelector(".about-mentions__pin"),
			refreshPriority: scenePriority(root),
		});
	}
});
